import type { ApiRoutes } from '@tempo-io/notification-app/rpc';
import { hc } from 'hono/client';
import type { KyInstance } from 'ky';

export const getNotificationServiceApi = ({
  prefixUrl = '',
  client,
}: {
  prefixUrl?: string;
  client: KyInstance;
}) =>
  hc<ApiRoutes>('/api/', {
    fetch: (input: RequestInfo | URL, requestInit?: RequestInit) => {
      return client(`${prefixUrl}${input}`, {
        method: requestInit?.method,
        headers: {
          'content-type': 'application/json',
          ...requestInit?.headers,
        },
        body: requestInit?.body,
      });
    },
  });
